/* global $ */

import { throttleDomAfterAsync } from '../helpers/throttle';

// class noting if browser has ever been resized (used to finish all css animation)
$(window).one('resize', () => $('html').addClass('was-resized'));

// dynamically recalculates the viewport height, taking mobile url bars into account.
// tradeoff if used will is a jumpiness on scroll on mobile browsers
const setVHUnitDesktop = () => {
	if (window.innerWidth > 580) {
		window.setVHUnit();
	}
};

window.addEventListener('resize', throttleDomAfterAsync(setVHUnitDesktop, 50));
window.addEventListener(
	'orientationchange',
	throttleDomAfterAsync(window.setVHUnit, 200),
);

/**
 * Get absolute height of elem. No jQuery.
 * 
 * @param {string|Node} el The elem.
 * @return The absolute height.
 */
function getAbsoluteHeight(el) {
	// Get the DOM Node if you pass in a string
	el = (typeof el === 'string') ? document.querySelector(el) : el;

	const styles = window.getComputedStyle(el);
	const margin = parseFloat(styles.marginTop) +
		parseFloat(styles.marginBottom);

	return Math.ceil(el.offsetHeight + margin);
}

/**
 * Handle homepage offset grid alignments.
 *
 * @param {string} intro The intro.
 * @param {string} grid The grid.
 */
function setHomeOffset(intro, grid) {
	const p = document.querySelector(grid);

	if (!p) {
		return;
	}

	p.style.setProperty('--cur-offset', '-' +  (getAbsoluteHeight(intro)) + 'px');
}

setHomeOffset('#hp-prio-intro', '#home-priorities-grid');
setHomeOffset('#home-latest-intro', '#home-latest-grid');

window.addEventListener('resize', function() {
	setHomeOffset('#hp-prio-intro', '#home-priorities-grid');
	setHomeOffset('#home-latest-intro', '#home-latest-grid');
});